
import { Edit, Trash, Eye } from "lucide-react";
import { Button } from "@/components/ui/button";

interface MobileCustomerCardProps {
  customer: {
    id: string;
    name: string;
    phone: string;
    whatsapp?: string;
    description?: string;
    transaction_count?: number;
    quotation_count?: number;
  };
  onViewDetails: (customer: any) => void;
  onEdit: (customer: any) => void;
  onDelete: (customer: any) => void;
}

export function MobileCustomerCard({
  customer,
  onViewDetails,
  onEdit,
  onDelete,
}: MobileCustomerCardProps) {
  return (
    <div className="bg-[#1A1E2C] dark:bg-[#1A1E2C] rounded-lg shadow mb-3 overflow-hidden border border-gray-800">
      {/* Header */}
      <div className="p-4">
        <h3 className="text-xl font-bold text-white dark:text-white mb-3">{customer.name}</h3>
        
        {customer.description && (
          <div className="bg-[#252A38] dark:bg-[#252A38] p-3 rounded mb-3">
            <span className="font-semibold block mb-1 text-white dark:text-white">Descrição:</span> 
            <p className="text-sm text-white dark:text-white">{customer.description}</p>
          </div>
        )}
        
        <div className="grid grid-cols-2 gap-2 text-sm mb-3">
          <div>
            <span className="text-gray-400 dark:text-gray-400">Telefone:</span>
            <p className="font-medium text-gray-200 dark:text-white">{customer.phone || "—"}</p>
          </div>
          <div>
            <span className="text-gray-400 dark:text-gray-400">WhatsApp:</span>
            <p className="font-medium text-gray-200 dark:text-white">{customer.whatsapp || "—"}</p>
          </div>
        </div>
        
        <div className="flex justify-between text-xs mt-2">
          <div className="bg-[#0073B7]/20 text-[#0073B7] px-2 py-1 rounded">
            <span className="font-bold">{customer.transaction_count || 0}</span> transações
          </div>
          <div className="bg-[#0073B7]/20 text-[#0073B7] px-2 py-1 rounded">
            <span className="font-bold">{customer.quotation_count || 0}</span> orçamentos
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className="flex border-t border-gray-800 dark:border-gray-800">
        <Button
          variant="ghost"
          className="flex-1 rounded-none py-2 text-sm text-[#0073B7] hover:bg-[#252A38] hover:dark:bg-[#252A38]"
          onClick={() => onViewDetails(customer)}
        >
          <Eye className="h-4 w-4 mr-1" /> Detalhes
        </Button>
        <div className="w-px bg-gray-800 dark:bg-gray-800" />
        <Button
          variant="ghost"
          className="flex-1 rounded-none py-2 text-sm text-[#0073B7] hover:bg-[#252A38] hover:dark:bg-[#252A38]"
          onClick={() => onEdit(customer)}
        >
          <Edit className="h-4 w-4 mr-1" /> Editar
        </Button>
        <div className="w-px bg-gray-800 dark:bg-gray-800" />
        <Button
          variant="ghost"
          className="flex-1 rounded-none py-2 text-sm text-[#E60026] hover:bg-[#252A38] hover:dark:bg-[#252A38]"
          onClick={() => onDelete(customer)}
        >
          <Trash className="h-4 w-4 mr-1" /> Excluir
        </Button>
      </div>
    </div>
  );
}
